(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5627],{

/***/ 99468:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maintenance",
      function () {
        return __webpack_require__(79999);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_maintenance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/maintenance/maintenance.module.scss
var maintenance_module = __webpack_require__(29878);
var maintenance_module_default = /*#__PURE__*/__webpack_require__.n(maintenance_module);
;// CONCATENATED MODULE: ./components/maintenance/CountDown/index.tsx



var calculateSecondsBetweenDates = function(endDate) {
    var startDateMs = new Date().getTime();
    var endDateMs = new Date(endDate).getTime();
    var differenceMs = endDateMs - startDateMs;
    return Math.floor(differenceMs / 1000);
};
var formatTime = function(time) {
    var days = String(Math.floor(time / 86400));
    var hours = String(Math.floor((time - Number(days) * 86400) / 3600));
    var minutes = String(Math.floor((time - Number(days) * 86400 - Number(hours) * 3600) / 60));
    var seconds = String(Math.floor(time - Number(days) * 86400 - Number(hours) * 3600 - Number(minutes) * 60));
    if (Number(days) < 10) days = "0" + days;
    if (Number(hours) < 10) hours = "0" + hours;
    if (Number(minutes) < 10) minutes = "0" + minutes;
    if (Number(seconds) < 10) seconds = "0" + seconds;
    return {
        days: days,
        hours: hours,
        min: minutes,
        sec: seconds
    };
};
var CountDown = function(param) {
    var endDate = param.endDate;
    var ref = (0,react.useState)(calculateSecondsBetweenDates(endDate)), countdown = ref[0], setCountdown = ref[1];
    var timerId = (0,react.useRef)({});
    (0,react.useEffect)(function() {
        timerId.current = setInterval(function() {
            setCountdown(function(prevState) {
                return prevState - 1;
            });
        }, 1000);
        return function() {
            return clearInterval(timerId.current);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (countdown <= 0) {
            clearInterval(timerId.current);
        }
    }, [
        countdown
    ]);
    var countArray = formatTime(countdown);
    return countdown > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (maintenance_module_default()).countdown_wrapper,
        children: Object.keys(countArray).map(function(elem, index, array) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (maintenance_module_default()).date_row,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (maintenance_module_default()).date_column,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (maintenance_module_default()).column_count,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: countArray[elem]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (maintenance_module_default()).column_title,
                                children: elem
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (maintenance_module_default()).column_count,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: index !== array.length - 1 && " :"
                        })
                    })
                ]
            }, index);
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {});
};
/* harmony default export */ var maintenance_CountDown = (CountDown);

// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
;// CONCATENATED MODULE: ./components/maintenance/index.tsx





var Maintenance = function(param) {
    var dbName = param.dbName, maintenanceInfo = param.maintenanceInfo, cacheControlVersion = param.cacheControlVersion, whiteLogoPath = param.whiteLogoPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (maintenance_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (maintenance_module_default()).logo_wrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (maintenance_module_default()).logo_div,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(whiteLogoPath, "?v=").concat(cacheControlVersion)),
                        alt: "Logo",
                        loading: "eager",
                        width: "200",
                        height: "40"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (maintenance_module_default()).contentCentered,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (maintenance_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: maintenanceInfo.maintenance_mode_text
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            children: "COMING SOON"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(maintenance_CountDown, {
                            endDate: maintenanceInfo.maintenance_mode_end_date
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var maintenance = (Maintenance);

;// CONCATENATED MODULE: ./pages/maintenance.tsx



var maintenance_Maintenance = function(param) {
    var dbName = param.dbName, maintenanceInfo = param.maintenanceInfo, cacheControlVersion = param.cacheControlVersion, whiteLogoPath = param.whiteLogoPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(maintenance, {
            dbName: dbName,
            maintenanceInfo: maintenanceInfo,
            whiteLogoPath: whiteLogoPath,
            cacheControlVersion: cacheControlVersion
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_maintenance = (maintenance_Maintenance);


/***/ }),

/***/ 29878:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"maintenance_main__69UXo","logo_wrapper":"maintenance_logo_wrapper__i5RMZ","contentCentered":"maintenance_contentCentered__Et12_","content":"maintenance_content__kbb99","logo_div":"maintenance_logo_div__EhpFe","date_column":"maintenance_date_column__FRTci","date_row":"maintenance_date_row__oV8vw","column_count":"maintenance_column_count__I_Foa","column_title":"maintenance_column_title__2QVIE","countdown_wrapper":"maintenance_countdown_wrapper__GA9_P"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(99468); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);